import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { FeedPage as FeedComponent } from '@/components/feed/FeedPage';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

const FeedPage = () => {
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader 
        title="Signal." 
        subtitle="Monitor your performance signals and access your analytics vault."
      />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <FeedComponent />
      </div>
    </Layout>
  );
};

export default FeedPage;